const RESERVED_FIREBASE_HELPER_RE = /^\/__\/(auth|firebase)(?:\/|$)/;

function safeParseUrl(href = '') {
  try {
    return new URL(String(href || ''), 'https://cassavachain.local');
  } catch (_) {
    return null;
  }
}

function hasParam(params, key) {
  try {
    return params?.has?.(key) || false;
  } catch (_) {
    return false;
  }
}

function isSignInMode(params) {
  try {
    return String(params?.get?.('mode') || '').trim() === 'signIn';
  } catch (_) {
    return false;
  }
}

function hasDirectMagicLinkEvidence(params) {
  const hasOobCode = hasParam(params, 'oobCode');
  const hasApiKey = hasParam(params, 'apiKey');
  return (
    String(params?.get?.('emailLink') || '').trim() === '1' ||
    isSignInMode(params) ||
    hasOobCode ||
    hasParam(params, 'token') ||
    (hasApiKey && (isSignInMode(params) || hasOobCode))
  );
}

function hasNestedContinueMagicLinkEvidence(params) {
  const rawContinueUrl = String(params?.get?.('continueUrl') || '').trim();
  if (!rawContinueUrl) return false;
  const nested = safeParseUrl(rawContinueUrl);
  if (nested && hasDirectMagicLinkEvidence(nested.searchParams)) return true;

  try {
    const decoded = decodeURIComponent(rawContinueUrl);
    return /(?:^|[?&#])(?:emailLink=1|mode=signIn|oobCode=|token=)/.test(decoded);
  } catch (_) {
    return /(?:^|[?&#])(?:emailLink=1|mode=signIn|oobCode=|token=)/.test(rawContinueUrl);
  }
}

export function isReservedFirebaseHelperPath(href = '') {
  const parsed = safeParseUrl(href);
  return RESERVED_FIREBASE_HELPER_RE.test(String(parsed?.pathname || ''));
}

export function isMagicLinkEntryUrl(href = '') {
  const parsed = safeParseUrl(href);
  if (!parsed) return false;
  if (isReservedFirebaseHelperPath(parsed.href)) return false;
  return hasDirectMagicLinkEvidence(parsed.searchParams) || hasNestedContinueMagicLinkEvidence(parsed.searchParams);
}

export function isAuthCriticalMagicLinkUrl(href = '') {
  const parsed = safeParseUrl(href);
  if (!parsed) return false;
  return isReservedFirebaseHelperPath(parsed.href) || isMagicLinkEntryUrl(parsed.href);
}
